const AGORA_LEAD_SECTION = '[data-agora-lead-capture]';
const AGORA_FORM_CONTROLS =
  'input:not([type="hidden"]), select, textarea, button[type="submit"], input[type="submit"]';
const AGORA_SUCCESS_COPY =
  /you(?:'|’)re on|thank you|thanks for|submission received|request received|successfully submitted|we(?:'|’)ll be in touch/i;

function agoraElements(root) {
  const elements = [...root.querySelectorAll('*')];

  elements.forEach((element) => {
    if (element.shadowRoot) elements.push(...agoraElements(element.shadowRoot));
  });

  return elements;
}

function agoraFormState(app) {
  const elements = [app, ...agoraElements(app)];
  const controls = elements.filter((element) => element.matches?.(AGORA_FORM_CONTROLS));
  const visibleControls = controls.filter(
    (element) =>
      !element.hidden &&
      element.getAttribute('aria-hidden') !== 'true' &&
      element.getClientRects().length > 0,
  );
  const text = elements
    .map((element) => element.shadowRoot?.textContent || '')
    .concat(app.textContent || '')
    .join(' ');

  return {
    controlCount: visibleControls.length,
    hasSuccessCopy: AGORA_SUCCESS_COPY.test(text),
  };
}

function agoraSectionFromEvent(event) {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

  for (const node of path) {
    if (!(node instanceof Element)) continue;

    const section = node.closest(AGORA_LEAD_SECTION);
    if (section) return section;
  }

  return null;
}

function agoraPublishLead(section) {
  if (section.dataset.agoraLeadPublished === 'true') return;
  if (!window.Shopify?.analytics?.publish) return;

  section.dataset.agoraLeadPublished = 'true';
  window.Shopify.analytics.publish('agora_lead_submitted', {
    form_id: section.dataset.agoraFormId || '',
  });
}

function agoraArmLeadWatcher(section) {
  const app = section.querySelector('.agora-lead__app');
  if (!app || section.dataset.agoraLeadPublished === 'true') return;

  const startingState = agoraFormState(app);
  if (startingState.controlCount === 0) return;

  window.clearInterval(Number(section.dataset.agoraLeadTimer || 0));

  let checksRemaining = 120;
  const timer = window.setInterval(() => {
    const state = agoraFormState(app);
    const successCopyAppeared = state.hasSuccessCopy && !startingState.hasSuccessCopy;
    const controlsDisappeared = startingState.controlCount > 0 && state.controlCount === 0;
    const formCompleted = successCopyAppeared || controlsDisappeared;

    if (formCompleted) {
      window.clearInterval(timer);
      delete section.dataset.agoraLeadTimer;
      agoraPublishLead(section);
      return;
    }

    checksRemaining -= 1;
    if (checksRemaining > 0) return;

    window.clearInterval(timer);
    delete section.dataset.agoraLeadTimer;
  }, 250);

  section.dataset.agoraLeadTimer = String(timer);
}

document.addEventListener(
  'submit',
  (event) => {
    const section = agoraSectionFromEvent(event);
    if (section) agoraArmLeadWatcher(section);
  },
  true,
);

document.addEventListener(
  'click',
  (event) => {
    const section = agoraSectionFromEvent(event);
    if (section) agoraArmLeadWatcher(section);
  },
  true,
);
